<template>
  <section class="p-2">
    <v-card>
      <!--         $route.query.name !== 'Transaction Limit' -->
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Setup Master Data Value</div>
        <div>
          <bread-crumb :bread-crumbs="['Master Data Map']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-card-title>
          <v-row class=" ">
            <v-col cols="12" md="3" class="mt-1">
              <v-autocomplete
                placeholder="Parameter Values"
                dense
                outlined
                multiple
                :items="parametersdataValueList"
                v-model="parameterdetails.parameter_value"
                class="rounded"
              ></v-autocomplete>
            </v-col>
            <v-btn color="primary" class="mt-2" small @click="save()">
              + Add
            </v-btn>
            <!---------------------------------------- add category from the sub category end  -------------------------------->
            <v-dialog v-model="dialogDelete" width="500">
              <v-card>
                <v-card-title class="border border-bottom">Delete</v-card-title>
                <v-card-text class="h5 py-3"
                  >Are you sure you want to delete this prameter?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    outlined
                    @click="deleteItemConfirm"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    outlined
                    @click="closeDelete"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>

        <template>
          <v-row class="mt-5">
            <v-col cols="12" md="3" lg="3" xs="12" class="mt-3">
              <label class="" style="font-size: 16px">
                Master Parameter:
                <b class="ms-3">{{ parameter }}</b></label
              >
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" lg="4" xs="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                single-line
                class="me-4 mx-2"
                dense
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <!---------------------------------- Master data value table  start------------------------------------------>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="p-1"
          :items="parameterValueList"
          :loading="isLoading"
          loading-text="Loading... Please wait"
          v-model="selectedItems"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-switch
                v-model="item.is_active"
                height="0px"
                color="success"
                dense
                @change="isactiveupdate(item)"
              ></v-switch>
              <!-- <v-icon small color="primary" class="mr-2" @click="editItem(item)">
                mdi-content-save-edit-outline
              </v-icon> -->
              <!-- <v-icon small color="primary" @click="deleteItem(item)">
                mdi-trash-can-outline
              </v-icon> -->
            </div>
          </template>
        </v-data-table>
        <!---------------------------------- Master data value table  end------------------------------------------>
        <loading :active="isLoading" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService.js";
import { Masterdatavalue } from "@/utils/validationCopy.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import {
  returnRnagemasterData,
  onnumberKeyDown,
} from "@/utils/ConstantDropdowns/masterDataRange.js";
export default {
  components: {
    BreadCrumb,
    Loading,
    // ageGroup,
    // transLimts,
  },
  name: "Master Data Map Value",
  mixins: [alerts],
  data() {
    return {
      ...Masterdatavalue,
      masterDataRange: returnRnagemasterData(),
      onnumberKeyDown,
      dialogDelete: false,
      isLoading: false,
      singleSelect: false,
      search: "",
      deleteId: "",
      parametersdataValueList: [],
      parameter: "",
      parameter_values: "",
      headers: [
        {
          text: "ID",
          value: "id",
          width: 130,
        },
        { text: "Name", value: "parameter_value_name" },
        { text: "Code", value: "parameter_value_code", width: 300 },
        { text: "Descripition", value: "description" },
        // { text: "Active", value: "is_active", sortable: false },
        { text: "Action", value: "actions", sortable: false },
      ],
      parameterValueList: [],
      selectedItems: [],
      parameterdetails: {
        send_country_cd: this.$route.query.country,
        map_level: this.$route.query.map_level,
        parameter_value: [],
        parameter: this.$route.query.id,
        txn_type: this.$route.query.txn_type,
      },
    };
  },

  computed: {
    showButton() {
      return this.selectedItems.length > 0;
    },
    formtitle() {
      return this.editedIndex === -1 ? "Add Value" : "Edit Value";
    },
  },

  watch: {},
  mounted() {
    console.log("route.query.code  " + JSON.stringify(this.$route.query.code));
    console.log("route.query.name  " + JSON.stringify(this.$route.query.name));
    console.log("route.query.id  " + JSON.stringify(this.$route.query.id));
    this.getallparametersvalue(this.$route.query.id);
    this.getParameterValueList(this.$route.query.id);
  },

  methods: {
    async getParameterValueList(id) {
      this.isLoading = true;
      try {
        const responseData = await setupService.getMasterParameterList(id);
        this.isLoading = false;
        if (responseData && responseData.data.status_code == 200) {
          this.parameterValueList = responseData.data.data[0];
          this.isLoading = false;
          // this.parametersdataValueList.unshift({
          //   text: "Select All",
          //   value: null,
          // });
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        this.parameterValueList = [];
      }
    },
    async getallparametersvalue(id) {
      this.isLoading = true;
      try {
        const responseData = await setupService.getParametersValues(id);
        this.isLoading = false;
        if (responseData && responseData.data.status_code == 200) {
          this.parametersdataValueList =
            responseData.data.data[0].parameter_values.map((ele) => {
              return {
                text: ele.value,
                value: ele.id,
              };
            });
          this.parameter = responseData.data.data[0].parameter_name;
          // this.parametersdataValueList.unshift({
          //   text: "Select All",
          //   value: null,
          // });
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },

    async save() {
      this.isLoading = true;
      try {
        const response = await setupService.addMasterData(
          this.parameterdetails
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getParameterValueList(this.$route.query.id);
          this.parameterdetails.parameter_value = "";
          this.isLoading = false;
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },
    async isactiveupdate(item) {
      item.is_active ? false : true;
      this.isLoading = true;
      try {
        const response = await setupService.updatemappingStatus({
          parameter: item.parameter,
          country: item.send_country_cd,
          map_level: "CW",
          is_active: item.is_active,
          payout_partner_id: null,
          map_id: item.id,
        });
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.getParameterValueList(this.$route.query.id);
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },

    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.id;
    },

    async deleteItemConfirm() {},

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        // this.prametervalues = Object.assign({}, this.defaultItem)
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },
    back() {
      this.$router.push({
        name: "Master Data Mapping",
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
label {
  font-size: 15px;
  color: black;
  margin-bottom: 0px !important;
}
.v-dialog .v-card {
  overflow: hidden !important;
}
.label.v-label.theme--light {
  margin-bottom: 0px !important;
}
.v-text-field__prepend-inner {
  border-left: 1px solid #c5c5c5;
  margin-left: 8px;
  padding-left: 8px;
}
</style>
